import angular from 'angular';
import Services from './services/services';
import Interceptors from './interceptors/interceptors';
import Components from './components/components';
import Directives from './directives/directives';
import Actions from './actions/actions';
import Stores from './stores/stores';

const commonModule = angular.module('tinaba.common', [
  Services.name,
  Interceptors.name,
  Components.name,
  Actions.name,
  Stores.name,
  Directives.name
]);

export default commonModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/common.js
 **/